var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    ref: "modal",
    attrs: {
      "title": _vm.title,
      "button-text": _vm.buttonText
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.normalizedMessage)
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }